import Modal from "../../../../modal";
import styles from "./styles.module.css";
import { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { functions } from "../../../../firebase";
import { LoaderDisbatch } from "../../../../contexts/loader";



const addComponent = functions.httpsCallable("addComponent");
export default function AddPage({
  appId,
  setOpen: setDropown,
}) {
  const setLoader = useContext(LoaderDisbatch);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const history = useHistory();

  const handleAddComp = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      const {
        data: { compId },
      } = await addComponent({
        name,
        appId,
      });
      setOpen(false);
      setName(false);
      setDropown(false);
      history.push(`/${appId}/canvas/components/${compId}`);
      setLoader(false);
    } catch (err) {
      console.log(err);
      setLoader(false);
      alert("sorry, we ran into a bug and couldn't create a new component");
    }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className={styles.add}>
        Add Component
      </button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div onMouseDown={(e) => e.stopPropagation()} className={styles.modal}>
          <div className={styles.modalTitle}>Add Component</div>
          <div className={styles.inputTitle}>Component Name</div>
          <input
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <button onClick={handleAddComp} className={styles.add}>
            Add Component
          </button>
        </div>
      </Modal>
    </>
  );
}



